// SPDX-License-Identifier: Apache-2.0
import GirafeHTMLElement from '../../base/GirafeHTMLElement';

export default class OauthComponent extends GirafeHTMLElement {
  templateUrl = './template.html';
  styleUrls = ['../../styles/common.css', './style.css'];

  public constructor(name: string = 'oauth') {
    super(name);
  }

  private registerEvents() {
    this.subscribe('oauth.status', () => this.refreshRender());
    this.subscribe(/oauth\.userInfo.*/, () => this.refreshRender());
  }

  public getDisplayName() {
    if (this.state.oauth.userInfo?.display_name) {
      return this.state.oauth.userInfo.display_name;
    } else if (this.state.oauth.userInfo?.username) {
      return this.state.oauth.userInfo.username;
    }
    return this.state.oauth.userInfo?.email ?? 'Unknown User';
  }

  public getFullName() {
    if (this.state.oauth.userInfo?.given_name) {
      return `${this.state.oauth.userInfo?.given_name} ${this.state.oauth.userInfo?.family_name}`;
    }

    // No full name
    return null;
  }

  /**
   * Gets the user initials
   * super_admin -> SA
   * Gustave-André de la Girouette -> GG
   * @returns
   */
  public getInitials() {
    const name = this.getFullName() ?? this.getDisplayName();
    const parts = name.split(/[\s_-]+/).filter((part: string) => part.length > 0);

    if (parts.length === 0) {
      return '??';
    } else if (parts.length === 1) {
      return parts[0].substring(0, 2).toUpperCase();
    }
    return (parts[0][0] + parts.at(-1)![0]).toUpperCase();
  }

  public onLoginClick() {
    if (!this.context.configManager.Config.oauth && !this.context.configManager.Config.gmfauth) {
      throw new Error('Authentication is not configured on this instance. Login cannot be done.');
    } else {
      this.context.authManager.login();
    }
  }

  public async onLogoutClick() {
    const logout = await window.gConfirm('Do you want to logout ?', 'Logout');
    if (logout) {
      this.context.authManager.logout();
    }
  }

  protected override connectedCallback() {
    super.connectedCallback();
    super.render();
    this.registerEvents();
    super.girafeTranslate();
  }
}
